/** @jsxImportSource @emotion/react */

interface IQrCode {
  // Base64 encoded SVG.
  qrCode: string;
}

// Rendered as an image rather than inline SVG, so nothing in the SVG from the backend can run in the page. The SVG has
// no size of its own, so the image sets it, smaller on short screens so the instructions below it fit too.
const QrCode = ({ qrCode }: IQrCode) => (
  <img
    src={`data:image/svg+xml;base64,${qrCode}`}
    alt=''
    css={{
      display: 'block',
      width: 'min(300px, 30vh)',
      maxWidth: '100%',
      height: 'auto',
    }}
  />
);

export default QrCode;
